/**
 * Created by seven on 2018/04/26.
 */

import moment from 'moment'

export default {
  customNumeric: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: value => {
      var valueStr = value.toString()
      if (valueStr.indexOf('.') >= 0) {
        var numStr = valueStr.substr(valueStr.length - 1, valueStr.length)
        return !(numStr % 5 !== 0)
      }
      return true
    }
  },
  customVerifyAfterDate: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: value => {
      let start = value.startDate
      let end = value.endDate
      if (moment(start, 'YYYY/MM/DD').isSameOrBefore(moment(end, 'YYYY/MM/DD'))) {
        return true
      }
      return false
    }
  },
  no_space: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: value => {
      if (value.indexOf(' ') >= 0) {
        return false
      }
      return true
    }
  },
  customTime: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (timeRange) => {
      let startFormat = moment(timeRange.start.HH + timeRange.start.mm, 'HH:mm')
      let endFormat = moment(timeRange.end.HH + timeRange.end.mm, 'HH:mm')
      if (startFormat.isSameOrAfter(endFormat)) {
        return false
      }

      return true
    }
  },
  mobileTaiwan: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (mobile) => {
      var rules = /^[+][8869]{4}[0-9]{8}$/
      // console.log(rules.test(mobile))
      if (!rules.test(mobile)) {
        return false
      } else {
        return true
      }
    }
  },
  customStrLen: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value, maxLen) => {
      var str = value.match(/[^ -~]/g)
      var currentLength = value.length + (str ? str.length : 0)

      if (currentLength > maxLen) {
        return false
      }
      return true
    }
  },
  checkDateRepeat: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
      if (value === 'dateRepeat') {
        return false
      }
      return true
    }
  },
  maxArrLen: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value, maxLen) => {
      return (value.length <= maxLen)
    }
  },
  minArrLen: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value, minLen) => {
      return (value.length >= minLen)
    }
  },
  validateHttpsUrl: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
      let regex = /^https?:\/\//
      return regex.test(value)
    }
  },
  // 條碼內容物除第 1 碼外只會有
  // 0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ + - .  這 39 個字元
  // ex: /AB20EC9
  phoneCode: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
      let regex = /^[/][A-Z0-9+-.]{7}/
      return regex.test(value)
    }
  },
  naturalCode: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
      let regex = /[A-Z]{2}\d{14}/
      return regex.test(value)
    }
  },
  // 為3-7位數字，但有可能為0開頭
  // 例外：因之前有極少數愛心碼有前置加X的識別，請一併掃瞄接收或掃瞄後自行剔除X均可
  loveCode: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
      let regex = /\d{3,7}/
      return regex.test(value)
    }
  },
  // 統一編號為 A B C D E F G H
  // A x 1
  // B x 2
  // C x 1
  // D x 2
  // E x 1
  // F x 2
  // G x 4
  // H x 1
  // 最後將所有數值加總, 被 10 整除就為正確
  // 若上述演算不正確並且 G 為 7 得話, 再加上 1 被 10 整除也為正確
  taxNumber: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
      let taxArray = value.trim().split('')
      if (taxArray.length !== 8) {
        return false
      } else {
        let mapper = [1, 2, 1, 2, 1, 2, 4, 1]
        let sum = taxArray.reduce((total, value, index) => {
          let subTotalNum = value * mapper[index]
          let subNum = 0
          if (subTotalNum >= 10) {
            let eachNumArr = subTotalNum.toString().split('')
            subNum = eachNumArr.reduce((subTotal, num) => subTotal + parseInt(num), 0)
          } else {
            subNum = subTotalNum
          }
          return total + subNum
        }, 0)
        return (sum % 10 === 0 || (taxArray[6] === '7' && (sum + 1) % 10 === 0))
      }
    }
  },
  customPhoneNum: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
      let rules = /[^\d()#\-\\+]/
      return !rules.test(value)
    }
  },
  customEmail: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
      /* eslint-disable */
      let rules = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      return rules.test(value)
    }
  },
  brand: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
      /* eslint-disable */
      // 第一個字不為符號，後面可帶有限制符號
      let rules = /^[A-Za-z0-9][\w\-.]*$/

      return rules.test(value)
    }
  },
  customPassword: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
        // let rules = /^[!-\-\/-~]*$|^[!-\-\/-~]+[\.]*[!-\-\/-~]+$/
      let rules = /(?=.*[0-9])(?=.*[a-zA-Z])([\w~!@#$%^&*()_+]+){8,16}/
      return rules.test(value)
    }
  },
  customPasswordLen: {
    getMessage: field => 'The ' + field + ' value is not truthy.',
    validate: (value) => {
      return !(value.length < 8 || value.length > 16)
    }
  },
}
